import { CalendarView } from "../features/calendar/Calendar.js";
import { WorldMap } from "../features/map/Map.js";
import { Profile } from "../features/profile/Profile.js";
import { WorkingHoursView } from "../features/working-hours/WorkingHours.js";

// M4: the live view surfaces (map/calendar/hours). M3: profile.
export function MapPage() {
  return <WorldMap />;
}

export function CalendarPage() {
  return <CalendarView />;
}

export function HoursPage() {
  return <WorkingHoursView />;
}

export function ProfilePage() {
  // M3: the full profile (edit + trips) with a link to the M2 Sharing screen.
  return <Profile />;
}
